// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__Qtm7f","left":"Anchor_left__yPDEm"};